export const SITE = {
  phoneDisplay: "(717) 356-0740",
  phoneHref: "tel:+17173560740",
  email: "service@atcpestcontrol.com",
  emailHref: "mailto:service@atcpestcontrol.com",
  address: "4131 Huffmanville Road, Glen Rock, PA 17327",
  hours: "Mon – Sat · 7 AM – 7 PM",
  founded: 1991,
  brand: "ATC",
  brandFull: "ATC Pest Control",
};

export const STATS = [
  { value: "35+", label: "Years", sub: "without a single termite retreat" },
  { value: "5,000+", label: "Families", sub: "protected across PA & MD" },
  { value: "$5B+", label: "In damage", sub: "caused by termites each year in the U.S." },
  { value: "4.8★", label: "Rating", sub: "from 148+ verified reviews" },
];

export const SIGNS = [
  {
    title: "Mud Tubes",
    desc: "Pencil-thin dirt tunnels along foundations, pipes, or walls — the highway termites build between soil and timber.",
    img: "/generated/sign_mud_tubes.jpg",
  },
  {
    title: "Discarded Wings",
    desc: "Piles of translucent wings near windows or light fixtures after a swarm. The first visible proof of a colony expanding.",
    img: "/generated/sign_wings.jpg",
  },
  {
    title: "Frass",
    desc: "Sawdust-like droppings that collect near wood. If you see it, termites are feeding — often for months already.",
    img: "/generated/sign_frass_real.webp",
  },
  {
    title: "Hollow Wood",
    desc: "Trim, beams, or flooring that sound hollow when tapped. Termites eat from inside out, leaving a paper-thin shell.",
    img: "/generated/sign_hollow_wood.jpg",
  },
];

export const PROCESS = [
  {
    n: "01",
    title: "Thorough Inspection",
    desc: "A certified technician walks every inch of your home inside and out — identifying active infestations, conducive conditions, and risk points. You'll get a clear, itemized treatment plan before a single dollar is spent.",
  },
  {
    n: "02",
    title: "Targeted Treatment",
    desc: "We apply Termidor via our Inject-O-Matic system, creating a continuous 360° perimeter around your foundation. Colony-level control. Family- and pet-safe. Zero shortcuts.",
  },
  {
    n: "03",
    title: "Long-Term Protection",
    desc: "Your treatment comes with a renewable warranty and 100% satisfaction guarantee. If subterranean termites return, we come back at no cost to you — for as long as you're covered.",
  },
];

export const DIFFERENTIATORS = [
  {
    title: "Local & Family-Owned",
    desc: "Founded in 1991. Still answered by the same family. We live in the towns we protect.",
  },
  {
    title: "35+ Years · Zero Retreats",
    desc: "Over three decades of termite work and not one customer has ever needed a retreatment.",
  },
  {
    title: "Licensed & Trained",
    desc: "Every technician completes a 3-year program — including certification from Purdue's Entomology department.",
  },
  {
    title: "Family & Pet-Safe",
    desc: "Eco-minded treatments that target termites effectively while staying gentle on the home around them.",
  },
  {
    title: "Fast Response",
    desc: "Termites don't wait. Neither do we. Calls answered the same day — treatments scheduled as soon as possible, usually that week.",
  },
  {
    title: "A+ BBB · 4.8★",
    desc: "Accredited, insured, and rated by the only people who count — the 148+ neighbors who left a review.",
  },
];

export const PLANS = [
  {
    name: "One-Time Termite Treatment",
    kicker: "For active infestations",
    points: [
      "Comprehensive treatment to eliminate the active colony",
      "1-year renewable subterranean termite warranty",
      "Optional Termite Insurance for free re-treatments",
      "If termites return within a year, we retreat at no cost",
      "Immediate relief with peace of mind built in",
    ],
  },
  {
    name: "Annual Protection Program",
    kicker: "For total, ongoing defense",
    points: [
      "Termites covered 100% if discovered on your property",
      "Free Wood Destroying Insect Report (WDIR) within 30 days of settlement",
      "Warranty transfers to new owners if you sell",
      "Comprehensive pest coverage year-round",
      "Free service calls between scheduled appointments",
    ],
  },
];

export const AREAS_PA = [
  "York", "Hanover", "Lancaster", "Harrisburg",
  "Gettysburg", "Hershey", "Carlisle", "Mechanicsburg",
];

export const AREAS_MD = [
  "Baltimore", "Towson", "Frederick", "Westminster",
  "Columbia", "Annapolis", "Silver Spring", "Rockville",
];

export const TESTIMONIALS = [
  {
    quote:
      "We've been with ATC for years and wouldn't trust anyone else for termite control. They're always prompt, professional, and get the job done right the first time. The peace of mind knowing our home is protected is priceless.",
    name: "Jennifer Parker",
    city: "Hanover, PA",
  },
  {
    quote:
      "Jason and the crew were fantastic from start to finish. The termite treatment went smoothly, and they took the time to explain everything. I feel confident knowing my home is protected.",
    name: "DT",
    city: "York, PA",
  },
  {
    quote:
      "Called on a Tuesday morning about mud tubes in the basement. They called me back within the hour and got me scheduled that same week. Thorough, respectful, and the price was fair. These folks are the real deal.",
    name: "Michael R.",
    city: "Lancaster, PA",
  },
];

export const NAV_LINKS = [
  { href: "#signs", label: "Signs" },
  { href: "#process", label: "Process" },
  { href: "#why", label: "Why ATC" },
  { href: "#areas", label: "Service Areas" },
  { href: "#reviews", label: "Reviews" },
];

export const IMAGES = {
  hero: "/generated/hero_home.jpg",
  technician: "/generated/technician_real.png",
  family: "/generated/hero_home.jpg",
  woodTexture: "/generated/sign_hollow_wood.jpg",
};
